// Unify the displayed name in headings without changing stored articles or body text.
export const headingText = text => String(text ?? '').replace(/čchi[-\s]+kung(?:em|u)?/gi, 'Qigong');
